<template>
  <div class="home">
    <h2 class="title">Dose Revisions</h2>
    คำนวณขนาดยาใหม่ โดยใช้ผลระดับยา 2 จุด ที่ steady state
    (ดูกราฟด้านล่างประกอบ)
    <ul id="input">
      <li>
        ระดับยาจุดที่ 1 (C1: peak;1-2 hr หลังให้ยาเสร็จ)
        <br /><input class="input" type="integer" v-model="c1" size="4px" />
        mcg/ml
      </li>

      <li>
        ระดับยาจุดที่ 2 (C2: trough; 30 นาทีก่อนให้ยา)
        <br /><input class="input" type="integer" v-model="c2" size="4px" />
        mcg/ml
      </li>

      <li>
        ระยะเวลาระหว่างระดับยาทั้ง 2 จุด (ΔT)
        <input class="input" type="integer" v-model="deltat" size="3px" />
        hrs
      </li>
      <li>
        ระยะเวลาที่ใช้ในการให้ยา (t infusion)
        <input class="input" type="integer" v-model="ti" size="2px" />
        hr(s)
      </li>
      <li>
        ระยะเวลาตั้งแต่เริ่มให้ยาจนถึงเวลาที่เจาะ C1
        <input class="input" type="integer" v-model="t1" size="2px" />
        hr(s)
      </li>
      <li>
        จำนวนครั้งที่ให้ยาใน 24 ชั่วโมง (A)
        <input class="input" type="integer" v-model="a" size="3px" />
        ครั้ง
      </li>
      <li>
        MIC
        <input class="input" type="integer" v-model="mic" size="4px" />
        mg/L
      </li>
      <li>
        ขนาดยาเดิมต่อวัน (Current TDD)
        <input class="input" type="integer" v-model="tdd" size="4px" />
        mg/day
      </li>
      <li>คำนวณ AUC:MIC ได้ {{ auc24hpermiccalc.toFixed(0) }} mcg-hr/mL</li>
      <li>
        AUC:MIC goal
        <input type="range" min="400" max="600" step="100" v-model="aucgoal" />
        <input class="input" type="integer" v-model="aucgoal" size="3px" />
        mcg-hr/mL
      </li>
      <div id="dose">
        New Dose <br /><img src="../assets/ivdrip.png" height="40px" />{{
          newtddcalc
        }}
        mg/day
        <span v-show="a > 1"
          >หรือ {{ newdosecalc }} mg q {{ intervalcalc }} hr
        </span>
      </div>
      <div id="warning">Maxdose 2 g/dose 4.5g/day (รวม loading dose)</div>
    </ul>
    Ke = {{ kecalc() }}, Csoi = {{ csoicalc.toFixed(2) }} mcg/ml, C3 =
    {{ c3calc.toFixed(2) }} mcg/ml, T1/2 = {{ hlcalc }} hrs, VD = {{vdcalc.toFixed(1)}} L, CLvanco = {{clvancocalc.toFixed(2)}} L/hr

    <h2 class="title">Estimate AUC:MIC</h2>
    คำนวณ AUC:MIC จากขนาดยาใหม่
    <ul id="input">
      <li>
        New Dose
        <input class="input" type="integer" v-model="manualtdd" size="4px" />
        mg/day
      </li>

      <li>Estimate AUC:MIC {{ estauccalc.toFixed(0) }} mcg-hr/mL</li>
    </ul>
    <h2 class="title">Vancomycin concentration graph over time</h2>
    <img src="../assets/graph.png" />
  </div>
</template>

<script>
export default {
  name: "doserevise",

  data() {
    return {
      c1: 20,
      c2: 10,
      deltat: 8,
      a: 2,
      mic: 1,
      t1:2,
      ti: 1,
      aucgoal: 500,
      tdd: 1000,
      manualtdd: 1500,
    };
  },
  methods: {
    kecalc() {
      return (Math.log(this.c1 / this.c2) / this.deltat).toFixed(3);
    }
  },
  computed: {
    csoicalc() {
      return this.c1 * Math.exp(this.kecalc() * this.t1calc);
    },
    c3calc() {
      return this.csoicalc * Math.exp(-this.kecalc() * this.t2calc);
    },
    t1calc() {
      return this.t1-this.ti;
    },
    t2calc() {
      return (24/this.a)-this.ti;
    },
    hlcalc() {
      return Math.round(0.693 / this.kecalc());
    },
    clvancocalc() {
      return this.tdd/this.auccalc;
    },
    vdcalc() {
      return this.clvancocalc/this.kecalc();
    },
    lintrap() {
      return this.ti*(this.csoicalc+this.c3calc)/2;
    },
    logtrap() {
      return ((24/this.a)-this.ti)*(this.csoicalc-this.c3calc)/Math.log(this.csoicalc / this.c3calc);
    },
    auccalc() {
      return (this.lintrap + this.logtrap)*this.a;
    },
    auc24hpermiccalc() {
      return this.auccalc/this.mic;
    },
    newtddcalc() {
      return (
        Math.round((this.tdd * this.aucgoal) / this.auc24hpermiccalc / 100) *
        100
      );
    },
    newdosecalc() {
      return Math.round(this.newtddcalc / this.a / 100) * 100;
    },
    intervalcalc() {
      return 24 / this.a;
    },
    estauccalc() {
      return (this.manualtdd * this.auc24hpermiccalc) / this.tdd;
    },
  },
};
</script>

<style scope>
div {
  margin-top: 10px;
}
ul#input li {
  display: list-item;
  list-style-type: none;
}
span#dose {
  font-size: 25px;
  color: #4f9bb2;
  background-color: #fccbcb;
}
div#dose {
  font-size: 25px;
  color: black;
  background-color: #fccbcb;
}
div#lddose {
  font-size: 20px;
  color: black;
  background-color: #fccbcb;
}
.input {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #364f6b;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px thin #4f9bb2;
}
</style>
